import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

export class SignalRFactory {

  static connection(
    hubUrl: string,
    accessTokenFactory: () => string,
    logLevel: LogLevel,
    transport: HttpTransportType = HttpTransportType.WebSockets
  ): HubConnection {
    return new HubConnectionBuilder()
      .withUrl(hubUrl, {
        skipNegotiation: true,
        transport, accessTokenFactory
      })
      .withAutomaticReconnect()
      .configureLogging(logLevel)
      .build()
  }
}
